import React, { useState, useEffect } from 'react'
import './overDP.css'
import { DataGrid } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { Link } from 'react-router-dom';

function OverDP() {
  const [data, setData] = useState([])

  const rows = data

  const columns = [
    { field: 'id', type: 'number', headerName: 'ID', width: 50, headerClassName: 'DPHeaderColor', align: 'center' },
    { field: 'organizer', headerName: 'Organizer', width: 200, headerClassName: 'DPHeaderColor' },
    { field: 'location', headerName: 'Location', width: 300, headerClassName: 'DPHeaderColor' },
    { field: 'startDateTime', headerName: 'Start Date & Time', width: 170, headerClassName: 'DPHeaderColor' },
    { field: 'endDateTime', headerName: 'End Date & Time', width: 170, headerClassName: 'DPHeaderColor' },
    { field: 'action', headerName: 'Actions', width: 100, headerClassName: 'DPHeaderColor', 
    renderCell: (params) => {
      return(
        <div className="DPActions">
          <Link to={`/updateDP/${params.id}`}>
            <EditIcon className='DPEditIcon'/>
          </Link>
          <DeleteIcon className='DPDeleteIcon' onClick={ () => handleDelete(params)}/>
        </div>
      ) } },
  ]

  const handleDelete = (clickedUser) => {
    let confirmAction = window.confirm("Are you sure you want to delete this Event?");
    
    if (confirmAction) {
      axios({
        method: 'post',
        url: 'https://blood147.000webhostapp.com/admin_panel/deleteDonationPrograms.php/?id=' + clickedUser.id
      })
      .then(function (response) {
          //handle success
          console.log(response)
          if(response.data === 'success') {
            const newUserArray = data.filter((item) => item.id !== clickedUser.id)
            setData(newUserArray)
            alert("Successfully deleted.");
          }
          else{
            alert("Delete failed. Server issues.");
          }
      })
      .catch(function (response) {
          //handle error
          console.log(response)
      });
    }
    
    else {
      alert("Action canceled");
    }
  }

  useEffect(() => {
    fetch('https://blood147.000webhostapp.com/admin_panel/readDonationPrograms.php')
    .then((response) => response.json())
    .then((users) => setData(users))
    .catch((error) => console.log(error))
  }, []);

  return (
    <div className="overDP">
      {/* rgba(255, 7, 0, 0.55) */}
            <DataGrid
            initialState={{
              sorting: {
                sortModel: [{ field: 'endDateTime', sort: 'desc' }],
              },
            }}
            sx={{
              boxShadow: 3,
              '& .DPHeaderColor': {
                color: '#1976d2'
              },
            }}
            rows={rows} columns={columns} disableSelectionOnClick={true} pageSize={10} />
    </div>
  )
}

export default OverDP